<template>
    <div 
        v-if="ephemeridesData"
        class="horoscope-data">
        <p>
            Die <b>Sonne</b> stand zum Zeitpunkt Ihrer Geburt
            <b>{{ ephemeridesData.Sonne.Grad }}</b> Grad
            {{ ephemeridesData.Sonne.Richtung }}
            im Zeichen
            <b>{{ ephemeridesData.Sonne.Zeichen }}</b>.
            Dies ist Ihr sogenanntes Tierkreiszeichen, auch gerne als "Sternzeichen" bezeichnet.
            Die Sonne symbolisiert das <b>Bewusstsein</b>, den <b>Geist</b>.
        </p>
        <p>
            Der <b>Mond</b> stand
            <b>{{ ephemeridesData.Mond.Grad }}</b> Grad
            {{ ephemeridesData.Mond.Richtung }}
            im Zeichen
            <b>{{ ephemeridesData.Mond.Zeichen }}</b>.
            Das ist Ihr Mondzeichen.
            Der Mond symbolisiert das <b>Unbewusste</b>, die <b>Materie</b>.
        </p>
        <p>
            <b>Merkur</b> (Verstand)
            <b>{{ ephemeridesData.Merkur.Grad }}</b> Grad
            {{ ephemeridesData.Merkur.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Merkur.Zeichen }}</b>.
        </p>
        <p>
            <b>Venus</b> (Weiblichkeit)
            <b>{{ ephemeridesData.Venus.Grad }}</b> Grad
            {{ ephemeridesData.Venus.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Venus.Zeichen }}</b>.
        </p>
        <p>
            <b>Mars</b> (Männlichkeit)
            <b>{{ ephemeridesData.Mars.Grad }}</b> Grad
            {{ ephemeridesData.Mars.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Mars.Zeichen }}</b>.
        </p>
        <p>
            <b>Jupiter</b> (Erweiterung)
            <b>{{ ephemeridesData.Jupiter.Grad }}</b> Grad
            {{ ephemeridesData.Jupiter.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Jupiter.Zeichen }}</b>.
        </p>
        <p>
            <b>Saturn</b> (Einschränkung)
            <b>{{ ephemeridesData.Saturn.Grad }}</b> Grad
            {{ ephemeridesData.Saturn.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Saturn.Zeichen }}</b>.
        </p>
        <p>
            <b>Uranus</b> (Revolution)
            <b>{{ ephemeridesData.Uranus.Grad }}</b> Grad
            {{ ephemeridesData.Uranus.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Uranus.Zeichen }}</b>.
        </p>
        <p>
            <b>Neptun</b> (Verschleierung)
            <b>{{ ephemeridesData.Neptun.Grad }}</b> Grad
            {{ ephemeridesData.Neptun.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Neptun.Zeichen }}</b>.
        </p>
        <p>
            <b>Pluto</b> (Unterwelt)
            <b>{{ ephemeridesData.Pluto.Grad }}</b> Grad
            {{ ephemeridesData.Pluto.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Pluto.Zeichen }}</b>.
        </p>
        <p>
            <b>Mondknoten</b> (Lebensweg)
            <b>{{ ephemeridesData.Mondknoten.Grad }}</b> Grad
            {{ ephemeridesData.Mondknoten.Richtung }}
            im Zeichen <b>{{ ephemeridesData.Mondknoten.Zeichen }}</b>.
        </p>
    </div>
</template>

<script>
export default {
    name: 'display-horoscope',
    props: {
        ephemeridesData: {
            Type: Object
        }
    }
};
</script>

<style scoped>
    .horoscope-data {
        margin-top: 30px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        padding: 35px 0 0 0;
    }
</style>
